// static config for disable label value todo...
export const electionContractAddress = 'QWMSafkNs3oydr7EqktZ7kR2cE8j9c8qAbKymds5FLQZXcPiD';
// for network-dao treasury account
export const treasuryAccountAddress = 'KNdM6U6PyPsgyena8rPHTbCoMrkrALhxAy1b8Qx2cgi4169xr';

// ------------------aelf-web-login-start------------------------
export const networkType = 'MAINNET';
export const aelfWebLoginNetworkType = 'MAIN';
export const rpcUrlAELF = 'https://aelf-public-node.aelf.io';
export const rpcUrlTDVV = 'https://tdvv-public-node.aelf.io';
export const rpcUrlTDVW = 'https://tdvv-public-node.aelf.io';
export const connectServer = 'https://auth-portkey.portkey.finance';
export const graphqlServer = 'https://indexer-api.aefinder.io/api/app/graphql/portkey';
export const portkeyServer = 'https://aa-portkey.portkey.finance';
export const connectUrl = 'https://auth-aa-portkey.portkey.finance';

export const TELEGRAM_BOT_ID = '7225715915';
// ------------------aelf-web-login-end------------------------

export const curChain = 'tDVV';
// system contract：token contract address
export const mainChainAddress = 'JRmBduh4nXWi1aXgdUsj5gJrzeZb2LxmrAbf7W99faZSvoAaE';
export const sideChainAddress = '7RzVGiuVWkvL4VfVHdZfQF2Tri3sgLe9U991bohHFfSRZXuGX';
export const sideChainCAContractAddress = '2UthYi7AHRdfrqc1YCfeQnjdChDLaas65bW4WxESMGMojFiXj9';
// tmrw contract: biz contract todo...
export const daoAddress = '2izSidAeMiZ6tmD7FKmnoWbygjFSmH5nko3cGJ9EtbfC44BycC';
export const propalAddress = '2tCM3oV6dTCmwFxSiFGPEVhGngdMwBV741wi156vj8kmqfp6da';
export const voteAddress = '2A8h4hLynLt86RxqvpNY43x6Js8CYhgyuAzj7sDGQ2ecP77Zgp';
export const treasuryContractAddress = 'TUeLJxSYY37kGbK8jf7NcLZ43g8k2DgQufgvzYjnsUzQsoCas';
// explorer config
export const explorer = 'https://aelfscan.io/tDVV';
export const mainExplorer = 'https://aelfscan.io/AELF';
// export const explorerRPC = 'https://explorer.aelf.io/chain';

// network-dao contract address: get network dao highCouncil table
export const electionContractAddr = 'NrVf8B7XUduXn1oGHZeF1YANFXEXAhvCymz2WPyKZt4DE2zSg';
export const consensusDPoSAddr = 'pGa4e5hNGsgkfjEGm72TEvbF7aRDqKBd4LuXtab4ucMbXLcgJ';

export const sideChainSuffix = 'tDVV';
// symbolmarket page url
export const symbolmarketUrl = 'https://www.eforest.finance/symbolmarket';

// explorer
// export const SOCKET_URL_NEW = 'wss://explorer.aelf.io';

// header
export const chainIdSelect = [
  {
    value: 'AELF',
    label: 'aelf MainChain',
  },
  {
    value: 'tDVV',
    label: 'aelf dAppChain',
  },
];

// network-dao
export const networkDaoId = 'e9e131724d50de8fce13629043dc8a58a6692be57417985972418159cd883d72';

// website
export const host = 'https://tmrwdao.com';

// telegram
export const nftSymbol = 'TOMORROWPASS-1';
export const nftSymbolId = '1';

// api
export const apiServerBase = 'https://api.tmrwdao.com';
